export interface Review {
  name: string;
  avatar: string;
  rating: number;
  date: string;
  content: string;
  tags: string[];
}

export const sampleReviews: Review[] = [
  {
    name: "顾小满",
    avatar:
      "https://readdy.ai/api/search-image?query=portrait%20headshot%20of%20a%20cheerful%20young%20chinese%20woman%20smiling%2C%20clean%20warm%20neutral%20background%2C%20soft%20studio%20lighting%2C%20natural%20and%20friendly%2C%20high%20detail&width=120&height=120&seq=review-user-01&orientation=squarish",
    rating: 5,
    date: "2026-09-28",
    content: "分量很足，味道也很正，送来的时候还是热的。包装干净，汤汁没有洒出来，会回购。",
    tags: ["分量足", "包装好"],
  },
  {
    name: "方宇",
    avatar:
      "https://readdy.ai/api/search-image?query=portrait%20headshot%20of%20a%20relaxed%20chinese%20young%20man%20smiling%2C%20clean%20warm%20neutral%20background%2C%20soft%20studio%20lighting%2C%20casual%20and%20friendly%2C%20high%20detail&width=120&height=120&seq=review-user-02&orientation=squarish",
    rating: 5,
    date: "2026-09-21",
    content: "第二次点了，口味稳定，配送速度比预计还快了两分钟，骑手小哥态度很好，给个好评。",
    tags: ["配送快", "口味稳定"],
  },
  {
    name: "周雅",
    avatar:
      "https://readdy.ai/api/search-image?query=portrait%20headshot%20of%20a%20gentle%20chinese%20woman%20smiling%20warmly%2C%20clean%20warm%20neutral%20background%2C%20soft%20studio%20lighting%2C%20kind%20and%20natural%2C%20high%20detail&width=120&height=120&seq=review-user-03&orientation=squarish",
    rating: 4,
    date: "2026-09-14",
    content: "整体挺好吃的，就是希望辣度可以再细分一点。下次想试试加溏心蛋，应该会更香。",
    tags: ["味道不错"],
  },
];